import { Reveal } from "@/components/Reveal";

const PIECES = [
  {
    src: "/renders/lineup-shoulder2.png",
    name: "Shoulder",
    quote: "Recovery Era.",
    pos: "object-[70%_50%]",
  },
  {
    src: "/renders/lineup-elbow2.png",
    name: "Elbow",
    quote: "Still Iconic.",
    pos: "object-[70%_50%]",
  },
  {
    src: "/renders/lineup-ankle.png",
    name: "Ankle",
    quote: "Torn, Not Broken.",
    pos: "object-center",
  },
];

export const Lineup = () => (
  <section data-testid="lineup-section" className="max-w-7xl mx-auto px-6 md:px-10 pb-28 md:pb-40">
    <Reveal>
      <p className="text-xs font-medium tracking-[0.25em] uppercase text-[#2C241E]/50 mb-4">
        05 / The Lineup
      </p>
      <h2
        data-testid="lineup-headline"
        className="font-display text-4xl md:text-6xl tracking-tighter text-[#2C241E] mb-6"
      >
        Worn. Not Hidden.
      </h2>
      <p className="text-base md:text-lg leading-relaxed text-[#2C241E]/65 max-w-2xl mb-14">
        Shoulder, elbow, ankle — each one carries its words. Knitted from an odourless,
        itch-free yarn that sits easy on skin, all day. A first glimpse before launch.
      </p>
    </Reveal>
    <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 md:gap-5">
      {PIECES.map((p, i) => (
        <Reveal key={p.name} delay={i * 0.08}>
          <div data-testid={`lineup-${p.name.toLowerCase()}`} className="group">
            <div className="rounded-2xl overflow-hidden aspect-[3/4] bg-[#E5DFD5] border border-[#2C241E]/10">
              <img
                src={p.src}
                alt={`Model wearing the LIGATEN ${p.name} support printed ${p.quote}`}
                loading="lazy"
                className={`w-full h-full object-cover ${p.pos} transition-transform duration-700 group-hover:scale-105`}
              />
            </div>
            <div className="mt-3 flex items-baseline justify-between gap-2">
              <p className="font-display text-lg md:text-xl text-[#2C241E]">{p.name}</p>
              <p className="font-display italic text-sm text-[#2C241E]/55">"{p.quote}"</p>
            </div>
            <p className="text-[10px] font-medium tracking-[0.2em] uppercase text-[#2C241E]/45 mt-1">
              Coming Soon
            </p>
          </div>
        </Reveal>
      ))}
    </div>
  </section>
);
